export default __webpack_public_path__ + "static/media/gallery-wip-emitter_08.07e59a4c.jpg";